const listShopES = {
	title: "Registra tu Negocio",
	subtitle: "Recibe reservas en línea",
	shopName: "Nombre del negocio",
	ownerName: "Nombre del dueño",
	email: "Correo electrónico",
	phone: "Teléfono",
	shopDescription: "Descripción breve de tu negocio",
	registerShop: "Registrar Tienda",
	alreadyHaveAccount: "¿Ya tienes una cuenta?",
	signIn: "Entrar",
	sending: "Enviando...",
	perkFreeTitle: "14 días de prueba gratis",
	perkFreeDesc: "Cancela cuando quieras",
	perk1Title: "Configura en 15 minutos",
	perk1Desc: "Sin conocimientos técnicos",
	perk2Title: "Recordatorios automáticos",
	perk2Desc: "Reduce las ausencias hasta un 40%",
	perk3Title: "Programa de referidos",
	perk3Desc: "Invita un negocio, ambos ganan un mes gratis",
	referralCode: "Código de referido (opcional)",
	referralCodePlaceholder: "Ej: ABC123",
	requestCategory: "¿No encuentras tu tipo de negocio? Sugerirlo",
	requestCategoryModal: {
		title: "Sugerir categoría",
		subtitle: "Sin Fila revisa todas las solicitudes de categoría. Si la aprobamos, podrás actualizarla desde tu cuenta.",
		suggestionPlaceholder: "Tu tipo de negocio (ej: Estudio de yoga)",
		emailPlaceholder: "Tu correo (opcional)",
		cancel: "Cancelar",
		send: "Guardar",
		sending: "Guardando…...",
		success: "Solicitud enviada. ¡Gracias!",
		error: "No se pudo enviar la solicitud.",
		fillRequired: "Por favor describe tu tipo de negocio.",
		invalidEmail: "Por favor ingresa un correo electrónico válido.",
	},
};

export default listShopES;
